import React from "react";
import type { SecondarySideBarType3 } from "app/components/sidebar3/types";

const noopFunc = () => void 0;

export interface ISecondarySideBarContext {
    params: any;
    currentPage: string;
    currentModule: string;
    toggleSecondaryBar: (isOpened: boolean) => void;
    setSecondaryBarType3?: (type: SecondarySideBarType3) => void;
}

export const SecondarySideBarContext = React.createContext<ISecondarySideBarContext>({
    params: null,
    currentPage: null,
    currentModule: null,
    toggleSecondaryBar: noopFunc,
    setSecondaryBarType3: noopFunc,
});
